Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSectionWheel = void 0;

exports.getSectionWheel = function (params) {
  var themeId = params.themeId || params.sectionWheels.defaultThemeId;
  var theme = params.sectionWheels.themes[themeId];

  if (!theme) {
    console.log("Warning: theme '".concat(themeId, "' not found"));
    return;
  }

  var styles = theme.styles[params.wheelId];

  if (!styles) {
    console.log("Warning: style for wheelId '".concat(params.wheelId, "' not found"));
    return;
  }

  var style = styles[params.variation];

  if (!style) {
    console.log("Warning: style variation '".concat(params.variation, "' for wheelId '").concat(params.wheelId, "' not found"));
    return;
  }

  var allData = theme.data[params.wheelId];

  if (!allData) {
    console.log("Warning: data for wheelId '".concat(params.wheelId, "' not found"));
    return;
  }

  var data = allData[params.variation];

  if (!data) {
    console.log("Warning: data variation '".concat(params.variation, "' for wheelId '").concat(params.wheelId, "' not found"));
    return;
  }

  var wheel = {
    style: style,
    elementNcss: theme.elementNcss,
    wrSystemTheme: theme.wrSystemTheme,
    wrSystemConfig: params.sectionWheels.wrSystemConfig
  };
  return {
    data: data,
    wheel: wheel
  };
};